module.exports = __webpack_public_path__ + "img/ic24Tag.cf5a478b.svg";